export const onboardLogo = {
  bindings: {
    width: '<',
  },
  template: require('./onboard-logo.html')
};